import { render, staticRenderFns } from "./studentsTableTesting.vue?vue&type=template&id=4cd38ff0&scoped=true&"
import script from "./studentsTableTesting.vue?vue&type=script&lang=js&"
export * from "./studentsTableTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd38ff0",
  null
  
)

export default component.exports